import { render, staticRenderFns } from "./UserRankingTable.vue?vue&type=template&id=9bf45c18&scoped=true&"
import script from "./UserRankingTable.vue?vue&type=script&lang=js&"
export * from "./UserRankingTable.vue?vue&type=script&lang=js&"
import style0 from "./UserRankingTable.vue?vue&type=style&index=0&id=9bf45c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf45c18",
  null
  
)

export default component.exports